import { MONAIDataset } from "./types";

export const MONAI_DATASETS: MONAIDataset[] = [
  // Medical Segmentation Decathlon Datasets
  {
    id: 'task03_liver',
    name: 'Task03_Liver',
    displayName: 'Liver and Liver Tumor (MSD)',
    modality: 'CT',
    task: 'segmentation',
    format: 'nifti',
    trainCount: 131,
    valCount: 70,
    classes: ['Background', 'Liver', 'Liver Tumor'],
    totalSize: '26 GB',
    status: 'ready',
    path: '/workspace/data/Task03_Liver',
    description: 'Liver and liver tumor segmentation benchmark',
  },
  {
    id: 'task07_pancreas',
    name: 'Task07_Pancreas',
    displayName: 'Pancreas (MSD)',
    modality: 'CT',
    task: 'segmentation',
    format: 'nifti',
    trainCount: 282,
    valCount: 139,
    classes: ['Background', 'Pancreas', 'Pancreatic Tumor'],
    totalSize: '3.2 GB',
    status: 'ready',
    path: '/workspace/data/Task07_Pancreas',
    description: 'Pancreas and tumor segmentation',
  },
  {
    id: 'task09_spleen',
    name: 'Task09_Spleen',
    displayName: 'Spleen (MSD)',
    modality: 'CT',
    task: 'segmentation',
    format: 'nifti',
    trainCount: 41,
    valCount: 20,
    classes: ['Background', 'Spleen'],
    totalSize: '1.5 GB',
    status: 'ready',
    path: '/workspace/data/Task09_Spleen',
    description: 'Spleen segmentation benchmark',
  },
  // MedMNIST 2D Datasets
  {
    id: 'pathmnist',
    name: 'PathMNIST',
    displayName: 'PathMNIST',
    modality: 'Pathology',
    task: 'classification',
    format: 'medmnist',
    trainCount: 89996,
    valCount: 10004,
    testCount: 7180,
    classes: ['Adipose', 'Background', 'Debris', 'Lymphocytes', 'Mucus', 'Smooth Muscle', 'Normal', 'Stroma', 'Tumor'],
    totalSize: '186 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/pathmnist',
    description: 'Colon pathology classification (9 classes)',
  },
  {
    id: 'chestmnist',
    name: 'ChestMNIST',
    displayName: 'ChestMNIST',
    modality: 'X-Ray',
    task: 'classification',
    format: 'medmnist',
    trainCount: 78468,
    valCount: 11219,
    testCount: 22433,
    classes: ['Atelectasis', 'Cardiomegaly', 'Effusion', 'Infiltration', 'Mass', 'Nodule', 'Pneumonia', 'Pneumothorax', 'Consolidation', 'Edema', 'Emphysema', 'Fibrosis', 'Pleural', 'Hernia'],
    totalSize: '92 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/chestmnist',
    description: 'Chest X-ray multi-label classification (14 classes)',
  },
  {
    id: 'dermamnist',
    name: 'DermaMNIST',
    displayName: 'DermaMNIST',
    modality: 'Dermoscopy',
    task: 'classification',
    format: 'medmnist',
    trainCount: 7007,
    valCount: 1003,
    testCount: 2005,
    classes: ['Actinic keratoses', 'Basal cell carcinoma', 'Benign keratosis', 'Dermatofibroma', 'Melanoma', 'Melanocytic nevi', 'Vascular lesions'],
    totalSize: '24 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/dermamnist',
    description: 'Dermoscopic skin lesion classification (7 classes)',
  },
  {
    id: 'octmnist',
    name: 'OCTMNIST',
    displayName: 'OCTMNIST',
    modality: 'Fundus',
    task: 'classification',
    format: 'medmnist',
    trainCount: 97477,
    valCount: 10832,
    testCount: 1000,
    classes: ['CNV', 'DME', 'Drusen', 'Normal'],
    totalSize: '26 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/octmnist',
    description: 'Retinal OCT classification (4 classes)',
  },
  {
    id: 'pneumoniamnist',
    name: 'PneumoniaMNIST',
    displayName: 'PneumoniaMNIST',
    modality: 'X-Ray',
    task: 'classification',
    format: 'medmnist',
    trainCount: 4708,
    valCount: 524,
    testCount: 624,
    classes: ['Normal', 'Pneumonia'],
    totalSize: '5 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/pneumoniamnist',
    description: 'Pediatric pneumonia chest X-ray classification',
  },
  {
    id: 'breastmnist',
    name: 'BreastMNIST',
    displayName: 'BreastMNIST',
    modality: 'Ultrasound',
    task: 'classification',
    format: 'medmnist',
    trainCount: 546,
    valCount: 78,
    testCount: 156,
    classes: ['Benign', 'Malignant'],
    totalSize: '2 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/breastmnist',
    description: 'Breast ultrasound classification',
  },
  {
    id: 'bloodmnist',
    name: 'BloodMNIST',
    displayName: 'BloodMNIST',
    modality: 'Pathology',
    task: 'classification',
    format: 'medmnist',
    trainCount: 11959,
    valCount: 1712,
    testCount: 3421,
    classes: ['Basophil', 'Eosinophil', 'Erythroblast', 'IG', 'Lymphocyte', 'Monocyte', 'Neutrophil', 'Platelet'],
    totalSize: '28 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/bloodmnist',
    description: 'Blood cell type classification (8 classes)',
  },
  // MedMNIST 3D Datasets
  {
    id: 'organmnist3d',
    name: 'OrganMNIST3D',
    displayName: 'OrganMNIST3D',
    modality: 'CT',
    task: 'classification',
    format: 'medmnist',
    trainCount: 972,
    valCount: 161,
    testCount: 610,
    classes: ['Bladder', 'Femur-L', 'Femur-R', 'Heart', 'Kidney-L', 'Kidney-R', 'Liver', 'Lung-L', 'Lung-R', 'Pancreas', 'Spleen'],
    totalSize: '148 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/organmnist3d',
    description: '3D abdominal organ classification (11 classes)',
  },
  {
    id: 'nodulemnist3d',
    name: 'NoduleMNIST3D',
    displayName: 'NoduleMNIST3D',
    modality: 'CT',
    task: 'classification',
    format: 'medmnist',
    trainCount: 1158,
    valCount: 165,
    testCount: 310,
    classes: ['Benign', 'Malignant'],
    totalSize: '87 MB',
    status: 'ready',
    path: '/workspace/data/medmnist/nodulemnist3d',
    description: '3D lung nodule malignancy classification',
  },
];
